import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TextField } from 'react-admin';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableProps } from 'shared/mui/Table';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { BooleanField } from 'shared/react-admin/Fields';

type ProviderShowTableProps = {
  sourceId?: string;
} & TableProps;

export const ProviderShowTable = ({
  sx,
  sourceId = 'originId',
}: ProviderShowTableProps): JSX.Element => {
  const translate = useTypedTranslate();

  return (
    <CardTable sx={sx} tableBodyProps={{ sx: { '& td': { width: '130px' } } }}>
      <TableRowWrapper label="ID">
        <TextField source={sourceId} />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.name')}>
        <TextField source="name" />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.alias')}>
        <TextField source="alias" />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.actived')}>
        <BooleanField source="active" />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.comment')}>
        <TextField emptyText="—" source="comment" />
      </TableRowWrapper>
    </CardTable>
  );
};
